export default "__VITE_ASSET__CqZ80qmW__"